export default __webpack_public_path__ + "static/media/erp-software.ca5da8c0.png";